import { ILeftNavLink } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/ILeftNavLink";

/**
 * Determines whether a descendent (including itself) of given {@param leftNavLink}
 * has the same identifier as {@code props.selectedIdentifier}
 */
const hideNonExpandedChildLinks = (
  leftNavLink: ILeftNavLink,
  selectedIdentifier: string | undefined
): boolean => {
  const isNode = leftNavLink.identifier === selectedIdentifier;
  if (isNode) {
    leftNavLink.childNavLinks = leftNavLink.childNavLinks
      .slice(0)
      .map((childNavLink) => ({ ...childNavLink, childNavLinks: [] }));
    return true;
  }

  let isChildNodeExpanded = false;
  for (const childNavLink of leftNavLink.childNavLinks) {
    const shouldExpandChildNode = hideNonExpandedChildLinks(
      childNavLink,
      selectedIdentifier
    );
    if (!shouldExpandChildNode) {
      childNavLink.childNavLinks = [];
    }
    isChildNodeExpanded = isChildNodeExpanded || shouldExpandChildNode;
  }

  return isChildNodeExpanded;
};

export const filterLinksToVisibleNodes = (
  leftNavLinks: ILeftNavLink[],
  selectedIdentifier: string
): ILeftNavLink[] => {
  // Shallow copy
  const rootNode: ILeftNavLink = {
    name: "",
    childNavLinks: leftNavLinks.slice(0),
    to: "",
  };
  hideNonExpandedChildLinks(rootNode, selectedIdentifier);
  return rootNode.childNavLinks;
};
